var ga = function () { };

String.prototype.hashCode = function () {
    let hash = 0, i, chr;
    if (this.length === 0) return hash;
    for (i = 0; i < this.length; i++) {
        chr   = this.charCodeAt(i);
        hash  = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
};


class Progress {

    constructor() {

        this.count = 0;
    }

    start() {

        this.count++;

        if (typeof (NProgress) != 'undefined') NProgress.start();
    }

    done() {

        if (typeof (NProgress) != 'undefined') NProgress.inc();

        if (--this.count <= 0)
        {
            this.count = 0;

            if (typeof (NProgress) != 'undefined') NProgress.done();
        }
    }

    abourt() {

        if (typeof (NProgress) != 'undefined') NProgress.done();
    }
}

var progress = new Progress();

class Loader {

    constructor() {
        this.files = [];
        this.countFiles = 0;
        this.callback = null;
    }

    load() {

        this.prepareFiles(arguments);

        let jsFiles = [];
        this.files.forEach((file) => {
            if (file.endsWith(".css")) {
                this.loadCss(file);
            }else if (file.endsWith(".js")) {
                jsFiles.push(file);
            }
            
            progress.start();
        });

        this.loadJs(jsFiles);
    }

    prepareFiles(args){
        this.files = [];
        if (args.length) {
            for (let i = 0; i < args.length; i++) {
                let argument = args[i];

                if (typeof argument == 'string') {
                    this.files.push(argument);
                } else if (typeof argument == 'object') { //array
                    argument.forEach((f) => {
                        this.files.push(f)
                    });
                } else if (typeof argument == 'function') {
                    this.callback = argument;
                } else {
                    console.error('unknown type', typeof(argument));
                }
            }
        }

        this.countFiles = this.files.length;
    }

    loadCss(url) {
        let urlHash = url.hashCode();

        //prevent reloading file
        if (this.fileAlreadyLoaded(urlHash)) {
            this.newFileGetLoaded();
            return;
        }

        let el = document.createElement("link");

        el.type = "text/css";
        el.rel = "Stylesheet";
        el.href = url;
        el.onload = () => {
            this.newFileGetLoaded();
        };
        el.setAttribute('data-urlhash', urlHash);

        if (document.getElementsByTagName('head')) {
            document.getElementsByTagName('head')[0].appendChild(el);
        } else {
            document.write(el.outerHTML);
        }
    }

    loadJs(files) {
        console.log(files[0]);
        if(!files || files.length == 0){
            return;
        }

        let onLoadFile = () => {
            this.newFileGetLoaded();
            files.shift();
            this.loadJs(files);
        };

        let url = files[0];
        let urlHash = url.hashCode();

        //prevent reloading file
        if (this.fileAlreadyLoaded(urlHash)) {
            // onLoadFile();
            // return;
        }

        let el = document.createElement("script");
        el.crossorigin = 'anonymous';
        el.src = url;
        el.defer = 'true';
        el.type = "text/javascript";
        el.setAttribute('async',false);

        el.onload = () => {
            onLoadFile();
        };
        el.setAttribute('data-urlhash', urlHash);

        if (document.getElementsByTagName('head')) {
            document.getElementsByTagName('head')[0].appendChild(el);
        } else {
            document.write(el.outerHTML);
        }
        
    }

    fileAlreadyLoaded(urlHash) {
        return document.querySelector("[data-urlhash='" + urlHash + "']") != null;
    }

    newFileGetLoaded() {

        progress.done();

        this.countFiles -= 1;
        if (this.finishLoadingAllFiles()) {
            this.callback && this.callback();
        }
    }

    finishLoadingAllFiles() {
        return this.countFiles == 0;
    }
}

var fasah;

new Loader().load("/fasah/1.0/core.js", function(){

    fasah = new Engine();

    fasah.init();
});

